import { render, staticRenderFns } from "./ApiPage.vue?vue&type=template&id=39684d67&"
import script from "./ApiPage.vue?vue&type=script&lang=js&"
export * from "./ApiPage.vue?vue&type=script&lang=js&"
import style0 from "./ApiPage.vue?vue&type=style&index=0&id=39684d67&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports